// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import './CustmizeRingOptionPrice.style';
import Link from '@scandipwa/scandipwa/src/component/Link';
import RingSettingIcon from 'Component/RingSettingIcon/RingSettingIcon.component';
import { GQLCurrencyEnum } from '@scandipwa/scandipwa/src/type/Graphql.type';

export class CustmizeRingOptionPrice extends PureComponent {
    static propTypes = {
        product: this.propTypes,
        showoptions: this.propTypes
    };

    state = {
        changeoptions: false
    }

    handleRemove(categories) {
        if (categories[categories.length - 1].name === "Setting") {
            if (JSON.parse(localStorage.getItem("diamond"))) {
                localStorage.setItem("step", "Diamond");
            } else {
                localStorage.setItem("step", "Setting");
            }
        } else {
            if (JSON.parse(localStorage.getItem("setting"))) {
                localStorage.setItem("step", "Setting");
            } else {
                localStorage.setItem("step", "Diamond");
            }
        }

        this.setState({
            changeoptions: true
        });
    }

    render() {
        const { product, showoptions } = this.props;
        const { selectedcustomoptions, variants, categories } = product;
        const categoryCustomization_info = categories ? categories[categories.length - 1]?.customization_info : "";
        const setting_link = categoryCustomization_info?.setting_link;

        const selectedoption_obj = Object.fromEntries(selectedcustomoptions);
        let price_tiers = [];
        let type_id = [];
        let productPrice = [];
        let image = '';

        if (variants?.length > 0) {
            const data = variants?.filter(function (item) {
                for (var key in selectedoption_obj) {
                    if (item.attributes[key]) {
                        if (item.attributes[key].attribute_value === undefined || item.attributes[key].attribute_value != selectedoption_obj[key])
                            return false;
                    }
                }
                return item;
            });

            if (data?.length > 0) {
                price_tiers = [data[0]?.price_tiers]
                type_id = [data[0]?.type_id]
                productPrice = [data[0]?.price_range]
                image = data[0]?.thumbnail?.url
            } else {
                price_tiers = [product?.price_tiers];
                type_id = [product?.type_id];
                productPrice = [product?.price_range];
                image = product?.thumbnail?.url;
            }
        } else {
            price_tiers = [product?.price_tiers];
            type_id = [product?.type_id];
            productPrice = [product?.price_range];
            image = product?.thumbnail?.url;
        }

        const currencySymbol = GQLCurrencyEnum.USD;
        let pricewithcurrency = '';
        let discountpricewithcurrency = '';
        let viewlink = "";

        if (productPrice?.length > 0) {
            if (productPrice[0]?.minimum_price?.final_price?.value !== productPrice[0]?.minimum_price?.regular_price?.value) {
                pricewithcurrency = new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: currencySymbol,
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                }).format(Math.round(productPrice[0]?.minimum_price?.regular_price?.value));
            }

            discountpricewithcurrency = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: currencySymbol,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }).format(Math.round(productPrice[0]?.minimum_price?.final_price?.value));
        }

        if (product?.configurable_options) {
            const configurable_options = Object.keys(product?.configurable_options);
            const selectedoption = [];
            configurable_options?.forEach(element => {
                if (selectedoption_obj[element]) {
                    selectedoption.push(`${element}=${selectedoption_obj[element]}`);
                }
            });

            viewlink = `${product?.url}?${selectedoption.join("&")}`;
        } else {
            viewlink = `${product?.url}`;
        }

        return (
            <div className="CustmizeRingOptionPrice">
                {
                    showoptions ?
                        this.state.changeoptions ? <RingSettingIcon /> :
                            <div className='ring-option'>
                                <div className='ring-option-container'>
                                    <div className="ProductPrice   ProductPrice-Price">
                                        <del className="ProductPrice-HighPrice">
                                            {
                                                productPrice?.length > 0 ?
                                                    productPrice[0]?.minimum_price?.final_price?.value !== productPrice[0]?.minimum_price?.regular_price?.value ?
                                                        pricewithcurrency
                                                        : "" : <></>
                                            }
                                        </del>
                                        {
                                            productPrice?.length > 0 ?
                                                <span className="ProductPrice-Price">
                                                    <span className="ProductPrice-PriceValue">
                                                        {discountpricewithcurrency}
                                                    </span>
                                                </span>
                                                : ""
                                        }
                                    </div>
                                    <div className='view-remove-option-container'>
                                        <Link
                                            block="CustmizeRingOptionPrice"
                                            elem="viewoption"
                                            to={viewlink}
                                        >
                                            <span>view</span>
                                        </Link>
                                        <span>&nbsp;|&nbsp;</span>
                                        <Link
                                            block="CustmizeRingOptionPrice"
                                            elem="viewoption"
                                            to={setting_link}
                                            onClick={() => this.handleRemove(categories)}
                                        >
                                            <span>change</span>
                                        </Link>
                                    </div>
                                </div>
                                <img src={image} />
                            </div>
                        : <div className="ProductPrice   ProductPrice-Price">
                            <del className="ProductPrice-HighPrice">
                                {
                                    productPrice?.length > 0 ?
                                        productPrice[0]?.minimum_price?.final_price?.value !== productPrice[0]?.minimum_price?.regular_price?.value ?
                                            pricewithcurrency
                                            : "" : <></>
                                }
                            </del>
                            {
                                productPrice?.length > 0 ?
                                    <span className="ProductPrice-Price">
                                        <span className="ProductPrice-PriceValue">
                                            {discountpricewithcurrency}
                                        </span>
                                    </span>
                                    : <></>
                            }
                            {
                                productPrice?.length > 0 ?
                                    <div className="ProductActions-DiscountPrice-Price">
                                        <span className="ProductActions-Discount">
                                            ({productPrice[0]?.minimum_price?.discount?.percent_off?.toFixed(0)}% off)
                                        </span>
                                    </div>
                                    : <></>
                            }
                        </div>
                }
            </div>
        );
    }
}

export default CustmizeRingOptionPrice;
